// Tiny logger: silent in production builds, console in development.
const enabled = process.env.NODE_ENV !== 'production';

export const logger = {
  debug: (...args) => { if (enabled) console.debug(...args); },
  info: (...args) => { if (enabled) console.info(...args); },
  warn: (...args) => { if (enabled) console.warn(...args); },
  error: (...args) => { if (enabled) console.error(...args); },
};

export default logger;
